import { ComponentPropsWithRef, FC } from 'react';
import { NewsletterRegistration } from '@layout/components/Footer/NewsletterRegistration.component';

export interface NewsletterPopinProps extends ComponentPropsWithRef<'div'> {
  close: () => void;
}

const NewsletterPopin: FC<NewsletterPopinProps> = ({ close }) => {
  return <NewsletterRegistration close={close} />;
};

export { NewsletterPopin };
